<template>
  <div>
    <div class="content-warp">
      <JoinStep :programId="programId"></JoinStep>
      <a-spin :spinning="loading">
        <!-- 小球报名 -->
        <SmallBallJoin v-if="joinChannel.smallball.indexOf(programId) > -1" class="marginTop20"></SmallBallJoin>
        <!-- 大球报名 -->
        <BigBallJoin v-else-if="joinChannel.bigball.indexOf(programId) > -1" class="marginTop20"></BigBallJoin>
        <!-- 重竞技报名 -->
        <HeaveJoin v-else-if="joinChannel.heave.indexOf(programId) > -1" class="marginTop20"></HeaveJoin>
      </a-spin>
    </div>
  </div>
</template>
<script>
import JoinStep from './step/JoinStep.vue'
// 重竞技报名
import HeaveJoin from './heaveCompetition/HeaveJoin'
// 小球报名
import SmallBallJoin from './smallBall/SmallBallJoin'
// 大球报名
import BigBallJoin from './bigBall/BigBallJoin'
export default {
  name: 'Join',
  components: {
    JoinStep,
    HeaveJoin,
    SmallBallJoin,
    BigBallJoin
  },
  mounted () {
    this.groupAll()
  },
  data () {
    return {
      loading: false,
      matchId: this.$route.query.matchId,
      programId: Number(this.$route.query.programId),
      joinChannel: {
        smallball: [],
        bigball: [],
        heave: []
      }
    }
  },
  methods: {
    groupAll () {
      this.loading = true
      this.$api.match.groupAll().then(res => {
        if (res.status === 0) {
          this.joinChannel = res.data
          localStorage.setItem('joinChannel', JSON.stringify(this.joinChannel))
        } else {
          this.$message.error(res.msg)
        }
      }).finally(() => {
        this.loading = false
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.content-warp {
  width: 1200px;
  margin: 0 auto;
  .marginTop20 {
    margin-top: 20px;
  }
}
</style>



// WEBPACK FOOTER //
// src/comm/components/join/DefaultJoin.vue